import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {
  private months = [
    'январь',
    'февраль',
    'март',
    'апрель',
    'май',
    'июнь',
    'июль',
    'август',
    'сентябрь',
    'октябрь',
    'ноябрь',
    'декабрь'
  ];

  getMonthString() {
    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth();
    return this.months[currentMonthIndex];
  }

  getMonthNumberString() {
    const currentDate = new Date();
    //В JavaScript метод getMonth() возвращает индексы месяцев от 0 до 11:
    const currentMonthIndex = currentDate.getMonth() + 1;
    if (currentMonthIndex < 10) return `0${currentMonthIndex}`;
    return `${currentMonthIndex}`;
  }

  getNowDateStringFormat() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}.${month}.${year}`;
  }

  getDateFromTimestamp(timestamp: number) {
    const date = new Date(Number(timestamp));
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }

  getDayOfMonthFromTimestamp(timestamp: number) {
    const date = new Date(timestamp);
    return date.getDate();
  }

  getYearFromYYYYmmDD(dateString: string) {
    const parts = dateString.split('-');
    if (parts.length === 3) {
      return parseInt(parts[0], 10);
    }
    return null;
  }

  formatDate(dateString: string) {
    const [year, month, day] = dateString.split('-');
    return `${day}.${month}.${year}`;
  }

  parseDateFromString(dateStr: string): Date {
    return moment(dateStr, 'DD-MM-YYYY hh:mm:ss').toDate();
  }

  // Parse a raw date string into parts, supporting 'DD.MM.YYYY', 'YYYY-MM-DD', ISO/Date strings.
  // Returns:
  // - day: day of month without leading zero
  // - month: two-digit month number
  // - year: four-digit year
  // - monthWord: Russian month name in nominative case (e.g., "январь")
  // - yearShort: last two digits of the year
  parseDateParts(rawDate?: string | Date | null): { day: string; month: string; year: string; monthWord: string; yearShort: string } {
    const pickDatePart = (val: string | null | undefined): string => {
      if (!val) return '';
      const spaceIdx = val.indexOf(' ');
      return spaceIdx > -1 ? val.substring(0, spaceIdx) : val;
    };

    let ddNum: number;
    let mmNum: number;
    let yyyyNum: number;

    if (rawDate instanceof Date) {
      ddNum = rawDate.getDate();
      mmNum = rawDate.getMonth() + 1;
      yyyyNum = rawDate.getFullYear();
    } else {
      const str = pickDatePart(String(rawDate ?? '')).trim();
      if (str.includes('.')) {
        const [d, m, y] = str.split('.');
        ddNum = Number(d);
        mmNum = Number(m);
        yyyyNum = Number(y);
      } else if (str.includes('-')) {
        const [y, m, d] = str.split('-');
        ddNum = Number(d);
        mmNum = Number(m);
        yyyyNum = Number(y);
      } else if (str) {
        const dObj = new Date(str);
        if (!isNaN(dObj.getTime())) {
          ddNum = dObj.getDate();
          mmNum = dObj.getMonth() + 1;
          yyyyNum = dObj.getFullYear();
        } else {
          const now = new Date();
          ddNum = now.getDate();
          mmNum = now.getMonth() + 1;
          yyyyNum = now.getFullYear();
        }
      } else {
        const now = new Date();
        ddNum = now.getDate();
        mmNum = now.getMonth() + 1;
        yyyyNum = now.getFullYear();
      }
    }

    const monthIndex = Math.max(1, Math.min(12, mmNum)) - 1;
    const monthWord = this.months[monthIndex];
    const day = String(ddNum);
    const month = String(mmNum).padStart(2, '0');
    const year = String(yyyyNum);
    const yearShort = year.slice(-2);

    return { day, month, year, monthWord, yearShort };
  }
}
